import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import Favourites from '../views/Favourites.vue'
import Categories from '../views/Categories.vue'
// import AllRecipes from '../views/All-recipes.vue'
import Signup from '../views/Signup.vue'
import Login from '../views/Login.vue'
import Forgot from '../views/Forgot.vue'
import Verify from '../views/Verify.vue'
import MealPlan from '../views/MealPlan.vue'
import ShoppingList from '../views/ShoppingList.vue'
import Profile from '../views/Profile.vue'
import CarbControl from '../views/lifestyle-tips/CarbControl.vue'
import EatingOnABudget from '../views/lifestyle-tips/EatingOnABudget.vue'
import MaintainingWeight from '../views/lifestyle-tips/MaintainingWeight.vue'
import SmartFoodSubstitutions from '../views/lifestyle-tips/SmartFoodSubstitutions.vue'
// import Recipe from '../views/Recipe.vue'

import HomeArabic from '../views/arabic/index.vue'
import RecipeArabic from '../views/arabic/recipe.vue'
import AllRecipeArabic from '../views/arabic/All-recipes.vue'


import firebase from 'firebase'
// import VuePageTransition from 'vue-page-transition'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import VueHtmlToPaper from 'vue-html-to-paper';
import VueMeta from 'vue-meta'

Vue.use(VueRouter);
// Vue.use(VuePageTransition);
Vue.use(Chartkick.use(Chart));
Vue.use(VueHtmlToPaper);
/* eslint-disable */
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

const routes = [
  {
    path: '/favourites',
    name: 'favourites',
    component: Favourites,
    meta: {
      requiresAuth : true,
      isEN: true
    }
  },
  {
    path: '/categories/:id',
    name: 'categories',
    component: Categories,
    meta: { isEN: true }
  },
  {
    path: '/signup',
    name: 'signup',
    component: Signup,
    meta: { isEN: true }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { isEN: true }
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: Forgot,
    meta: { isEN: true }
  },
  {
    path: '/verify',
    name: 'verify',
    component: Verify,
    meta: { isEN: true }
  },
  {
    path: '/mealPlan',
    name: 'mealPlan',
    component: MealPlan,
    meta: {
      requiresAuth : true,
      isEN: true
    }
  },
  {
    path: '/ShoppingList',
    name: 'ShoppingList',
    component: ShoppingList,
    meta: {
      requiresAuth : true,
      isEN: true
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      requiresAuth : true,
      isEN: true
    }
  },
  {
    path: '/lifestyle-tips/CarbControl/',
    name: 'CarbControl',
    component: CarbControl,
    meta: {
      requiresAuth : false,
      isEN: true
    }
  },
  {
    path: '/lifestyle-tips/EatingOnABudget/',
    name: 'EatingOnABudget',
    component: EatingOnABudget,
    meta: {
      requiresAuth : false,
      isEN: true
    }
  },
  {
    path: '/lifestyle-tips/MaintainingWeight/',
    name: 'MaintainingWeight',
    component: MaintainingWeight,
    meta: {
      requiresAuth : false,
      isEN: true
    }
  },
  {
    path: '/lifestyle-tips/SmartFoodSubstitutions/',
    name: 'SmartFoodSubstitutions',
    component: SmartFoodSubstitutions,
    meta: {
      requiresAuth : false,
      isEN: true
    }
  },
  {
    path: '/',
    name: 'HomeArabic',
    component: HomeArabic,
    meta: { isAR: true }
  },
  {
    path: '/recipe/:id',
    name: 'RecipeArabic',
    component: RecipeArabic,
    meta: { isAR: true }
  },
  {
    path: '/all-recipes',
    name: 'AllRecipeArabic',
    component: AllRecipeArabic,
    meta: { isAR: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  // check is route requires the user to be signed in
  // window.scrollTo(0, 0)
  if(to.matched.some(rec => rec.meta.requiresAuth)){
    // check auth
    let user = firebase.auth().currentUser

    if(user){
      next()
    } else{
      next({name: 'login'})
    }
  } else {
    next()
  }
})

export default router
